var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120.74 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.05,133.76S88.74,99.89,99.59,85c9.27-12.75,18.63-25.79,21.15-29.31-6.26-2.21-14.09-6.09-17.83-5.65-4,.47-13.29,8.39-15.06,7.23s1.77-3,2-5.13S83.42,27,81.43,25.32s-10.18,1.86-12-.7-4-11.42-2.21-22.14C60,2.6,37.79,2.61,6.14,0L0,188.7c30.14,2,55.79,3.22,62.83,3.3l2.07-3.91c0-1.54,0-2.88,0-2.88a4,4,0,0,1,.44.17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMb);
export default __webpack_public_path__ + "static/media/MB.8712c8a6d2964c83ff5a4699e08d586f.svg";
export { ForwardRef as ReactComponent };